import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';

type Prop = {
  color?: string;
  mt?: number;
};

export const CorrectCheckIcon = (props: Prop) => {
  const { color = 'green.500', mt = 1 } = props;

  return <CheckCircleIcon color={color} mt={mt} />;
};

export const CustomWarningIcon = (props: Prop) => {
  const { color = 'red.500', mt = 1 } = props;
  return <WarningIcon color={color} mt={mt} />;
};
